import type { HttpErrorHandlerRepository } from '@/domains/http/httpErrorHandler.repository';
import { httpErrorHandlerService } from '@/infra/services/httpErrorHandler.service';

let _httpErrorHandlerService: HttpErrorHandlerRepository | null = null;

/**
 * Función que inyecta una instancia de HttpErrorHandlerService
 * Proporciona acceso centralizado al servicio de manejo de errores HTTP
 */
export const getHttpErrorHandlerService = (): HttpErrorHandlerRepository => {
  if (!_httpErrorHandlerService) {
    _httpErrorHandlerService = httpErrorHandlerService;
  }
  return _httpErrorHandlerService;
};

/**
 * Función para resetear las instancias (útil para testing)
 */
export const resetHttpContainer = (): void => {
  _httpErrorHandlerService = null;
};
